// extracted by mini-css-extract-plugin
module.exports = {"operations":"index_operations__3KHGi","users":"index_users__2qZdI","button":"index_button__1t8P8","devider":"index_devider__pUyXJ","right_btn":"index_right_btn__1k4Yo"};